<template>
    <div class="outer">
<!-- Generator: Adobe Illustrator 24.2.1, SVG Export Plug-In  -->
<svg id="orderstar" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="69.5px"
	 height="69.5px" viewBox="0 0 69.5 69.5" style="overflow:visible;enable-background:new 0 0 69.5 69.5;" xml:space="preserve">
<defs>
</defs>
<g id="Layer_2_2_">
	<g id="Layer_1-2_1_">
		<polygon class="cls-1delve" points="34.7,69.5 24.6,59.3 10.2,59.3 10.2,44.9 0,34.7 10.2,24.6 10.2,10.2 24.6,10.2 34.7,0 44.9,10.2 59.3,10.2 
			59.3,24.6 69.5,34.7 59.3,44.9 59.3,59.3 44.9,59.3 		"/>
	</g>
</g>
<g>
	<path class="cls-2white" d="M21.5,32.6c0.5,0.6,0.8,1.4,0.8,2.4c0,1.1-0.3,2-0.8,2.6s-1.2,0.9-2,0.9c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.1-0.4-0.3-0.5-0.6
		v3.3h-1.7V32h1.6v0.9c0.2-0.3,0.4-0.5,0.6-0.7c0.4-0.3,0.8-0.4,1.3-0.4C20.4,31.8,21,32.1,21.5,32.6z M20.3,33.8
		c-0.2-0.4-0.6-0.6-1.1-0.6c-0.6,0-1,0.3-1.3,0.9c-0.1,0.3-0.2,0.7-0.2,1.2c0,0.7,0.2,1.3,0.6,1.6c0.2,0.2,0.5,0.3,0.8,0.3
		c0.5,0,0.8-0.2,1.1-0.5s0.4-0.8,0.4-1.4C20.6,34.7,20.5,34.2,20.3,33.8z"/>
<path class="cls-2white" d="M25.2,31.2h-1.7v-1.5h1.7V31.2z M23.5,32h1.7v6.4h-1.7V32z"/>
	<path class="cls-2white" d="M30.7,34.3c0-0.2-0.1-0.5-0.2-0.6c-0.2-0.3-0.5-0.4-0.9-0.4c-0.6,0-0.9,0.3-1.2,0.8c-0.1,0.3-0.2,0.7-0.2,1.2
		c0,0.5,0.1,0.8,0.2,1.1c0.2,0.5,0.6,0.8,1.1,0.8c0.4,0,0.7-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8h1.7c0,0.5-0.2,1-0.6,1.4
		c-0.5,0.7-1.3,1.1-2.3,1.1s-1.8-0.3-2.3-0.9c-0.5-0.6-0.7-1.4-0.7-2.4c0-1.1,0.3-1.9,0.8-2.6c0.5-0.6,1.3-0.9,2.2-0.9
		c0.8,0,1.5,0.2,2,0.5s0.8,1,0.9,1.9H30.7z"/>
	<path class="cls-2white" d="M33.5,29.7h1.6v4.7l2.1-2.4h2.1L37,34.4l2.4,4h-2l-1.5-2.7l-0.7,0.7v2h-1.6V29.7z"/>
<path class="cls-2white" d="M41.9,32v3.8c0,0.4,0,0.6,0.1,0.8c0.2,0.3,0.4,0.5,0.9,0.5c0.6,0,1-0.2,1.2-0.7c0.1-0.2,0.2-0.6,0.2-1V32h1.7v6.4h-1.6
		v-0.9c0,0-0.1,0.1-0.1,0.2s-0.1,0.2-0.2,0.3c-0.3,0.2-0.5,0.4-0.8,0.5s-0.5,0.1-0.9,0.1c-0.9,0-1.6-0.3-1.9-1
		c-0.2-0.4-0.3-0.9-0.3-1.7V32H41.9z"/>
<path class="cls-2white" d="M52.9,32.6c0.5,0.6,0.8,1.4,0.8,2.4c0,1.1-0.3,2-0.8,2.6c-0.5,0.6-1.2,0.9-2,0.9c-0.5,0-0.9-0.1-1.3-0.4
		c-0.2-0.1-0.4-0.3-0.5-0.6v3.3h-1.7V32h1.6v0.9c0.2-0.3,0.4-0.5,0.6-0.7c0.4-0.3,0.8-0.4,1.3-0.4C51.7,31.8,52.4,32.1,52.9,32.6z
		 M51.6,33.8c-0.2-0.4-0.6-0.6-1.1-0.6c-0.6,0-1,0.3-1.3,0.9c-0.1,0.3-0.2,0.7-0.2,1.2c0,0.7,0.2,1.3,0.6,1.6
		c0.2,0.2,0.5,0.3,0.8,0.3c0.5,0,0.8-0.2,1.1-0.5c0.2-0.4,0.4-0.8,0.4-1.4C52,34.7,51.8,34.2,51.6,33.8z"/>
</g>
</svg>


    </div>
</template>



<script>
export default{


}



</script>


<style>


.outer{
    text-align: center;
    position: absolute;
    top: 0;

    left: 50%;
    transform: translateX(-50%);

}
.cls-1{fill:#f05d5b;}.cls-2{fill:#fff;}



.cls-1delve{fill:#f05d5b;}.cls-2white{fill:#fff;}

svg#order{



  width: 100px;
  /* height: 100px; */
  /* height: 40px; */
margin: 0 auto;
}


svg#orderstar{
	width: 100px;
	height: 100px;
	margin: 0 auto;
}


</style>